export default __webpack_public_path__ + "static/media/logo.8c0b6449.svg";